import i18n from 'i18next';

const translate = (key: string, defaultValue: string = ''): string => {
	try {
		const result = i18n.t(key);
		// 确保返回的是字符串，且不包含无效字符
		if (typeof result === 'string' && result.length > 0) {
			return result;
		}
		return defaultValue || key;
	} catch (e) {
		console.warn(`[i18n] Translation failed for key: ${key}`, e);
		return defaultValue || key;
	}
};

let Str_MemberModifyGroupNickname = translate('groupMemberModifyGroupNickname', '');
let Str_MemberSendImage = translate('groupMemberSendImage');
let Str_MemberJoinGroupMessage = translate('groupMemberJoinGroupMessage');
let Str_MemberLeaveGroupMessage = translate('groupMemberLeaveGroupMessage');
let Str_MemberSendVideo = translate('groupMemberSendVideo');
let Str_MemberSendDocument = translate('groupMemberSendDocument');
let Str_SetFontStyle = translate('setFontStyle');

let Str_DelAndClean = translate('DelAndClean');
let Str_SelectCountryRegion = translate('selectCountryRegion');
let Str_ClickQuery = translate('ClickQuery');
let Str_TingTongText = translate('TingTongText');
let Str_QueryFail = translate('QueryFail');
let Str_GroupMessaging = translate('GroupMessaging');
let Str_NetworkConnectFail = translate('NetworkConnectFail');
let Str_GroupApplyTip = translate('groupApplyTip');
let Str_InputGroupContent = translate('InputGroupContent');
let Str_SelectAll = translate('selectAll');
let Str_UnSelectAll = translate('unSelectAll');
let Str_MassSendingAssistant = translate('MassSendingAssistant');
let Str_CreatTopicErr = translate('CreatTopicErr');
let Str_SendComplete = translate('SendComplete');

let Str_CurrenAccInUse = translate('currenAccInUse');
let Str_EmptyNotSend = translate('EmptyNotSend');
let Str_AccDelTip = translate('AccDelTip');
let Str_SwitchAccTip = translate('switchAccTip');
let Str_SwitchAccSuc = translate('switchAccSuc');
let Str_Clear = translate('Clear');
let Str_NowUse = translate('NowUse');
let Str_Manage = translate('Manage');
let Str_AddAccount = translate('AddAccount');

let Str_ScannerPictureError = translate('ScannerPictureError');
let Str_SwitchAccount = translate('SwitchAccount');
let Str_ReadAgreed = translate('readAgreed');
let Str_ReadAgreedTip = translate('readAgreedTip');
let Str_UserAgreement = translate('UserAgreement');
let Str_PrivacyPolicy = translate('PrivacyPolicy');
let Str_AddFriendTip = translate('AddFriendTip');
let Str_AccountLogin = translate('accountLogin');
let Str_PhoneLogin = translate('phoneLogin');
let Str_Confirm = translate('confirm');
let Str_Skip = translate('skip');
let Str_Cancel = translate('cancel');
let Str_Complete = translate('complete');
let Str_ReSend = translate('reSend');
let Str_CodeAlreadySend = translate('codeAlreadySend');
let Str_SendCode = translate('sendCode');
let Str_Code = translate('code');
let Str_CodeSendFail = translate('codeSendFail');
let Str_ForgotPsd = translate('forgotPsd');
let Str_RememberPsd = translate('rememberPsd');
let Str_Register = translate('register');
let Str_LoginRegister = translate('loginRegister');
let Str_LoginByCode = translate('loginByCode');
let Str_LoginByPsd = translate('loginByPsd');
let Str_LoginNow = translate('loginNow');
let Str_NotSet = translate('notSet');
let Str_Avatar = translate('avatar');
let Str_Account = translate('account');
let Str_Nick = translate('nick');
let Str_Telno = translate('telno');
let Str_SetTelno = translate('setTelno');
let Str_UpdateTelno = translate('UpdateTelno');

let Str_InputTelno = translate('inputTelno');
let Str_Sex = translate('sex');
let Str_Man = translate('man');
let Str_Woman = translate('woman');
let Str_NotDisclose = translate('notDisclose');
let Str_SetSex = translate('setSex');
let Str_InputSex = translate('inputSex');
let Str_Remarks = translate('remarks');
let Str_SetRemarks = translate('setRemarks');
let Str_InputRemarks = translate('inputRemarks');
let Str_GroupName = translate('groupName');
let Str_SetGroupName = translate('setGroupName');
let Str_InputGroupName = translate('inputGroupName');
let Str_GroupNotice = translate('groupNotice');
let Str_SetGroupNotice = translate('setGroupNotice');
let Str_InputGroupNotice = translate('inputGroupNotice');
let Str_GroupNick = translate('groupNick');
let Str_SetNick = translate('setNick');
let Str_ToVerify = translate('toVerify');
let Str_PersonalInfo = translate('personalInfo');
let Str_Birthday = translate('birthday');
let Str_ImgUploading = translate('imgUploading');
let Str_ImgUploadFail = translate('imgUploadFail');
let Str_ScannerEnter = translate('scannerEnter');
let Str_ServiceNumberCommonErr = translate('serviceNumber.commonErr');
let Str_ServiceNumberCommonErr1 = translate('serviceNumber.commonErr1');
let Str_ServiceNumberCommonErr2 = translate('serviceNumber.commonErr2');
let Str_ServiceNumberInputHint = translate('serviceNumber.inputHint');
let Str_LoginLoading = translate('login.loginTip');
let Str_SwitchUserFail = translate('switchUserFail');
let Str_NickNotNull = translate('nickNotNull');
let Str_AccFormatErr = translate('accFormatErr');
let Str_AccNotNull = translate('accNotNull');
let Str_PsdNotNull = translate('psdNotNull');
let Str_PsdNotEmpty = translate('psdNotEmpty');
let Str_PsdOldNotNull = translate('psdOldNotNull');
let Str_PsdLengthErr1 = translate('psdLengthErr1');
let Str_PsdLengthErr2 = translate('psdLengthErr2');
let Str_PsdOldLengthErr1 = translate('psdOldLengthErr1');
let Str_PsdOldLengthErr2 = translate('psdOldLengthErr2');
let Str_PsdFormatErr = translate('psdFormatErr');
let Str_LogoutErr = translate('logoutErr');
let Str_PsdInconsistent = translate('psdInconsistent');
let Str_PhoneFormatErr = translate('phoneFormatErr');
let Str_EmailFormatErr = translate('emailFormatErr');
let Str_Registering = translate('registering');
let Str_RegisterSuc = translate('registerSuc');
let Str_RegisterFail = translate('registerFail');
let Str_InputNick = translate('inputNick');
let Str_InputAcc = translate('inputAcc');
let Str_InputAcc2 = translate('inputAcc2');
let Str_InputAcc3 = translate('inputAcc3');
let Str_InputAcAgain = translate('inputAcAgain');
let Str_InputCode = translate('inputCode');
let Str_InputPhone = translate('inputPhone');
let Str_InputEmail = translate('inputEmail');
let Str_InputPsd = translate('inputPsd');
let Str_InputPsdAgain = translate('inputPsdAgain');
let Str_InputProblem = translate('inputProblem');
let Str_InputAnswer = translate('inputAnswer');
let Str_HasAcc = translate('hasAcc');
let Str_Binding = translate('binding');
let Str_BindSuc = translate('bindSuc');
let Str_BindFail = translate('bindFail');
let Str_BindPhone = translate('bindPhone');
let Str_BindEmail = translate('bindEmail');
let Str_PlaceholderPsd = translate('placeholderPsd');
let Str_PlaceholderProblem = translate('placeholderProblem');
let Str_PlaceholderAnswer = translate('placeholderAnswer');
let Str_SetSuc = translate('setSuc');
let Str_SetFail = translate('setFail');
let Str_Psd = translate('psd');
let Str_Problem = translate('problem');
let Str_Answer = translate('answer');
let Str_PhoneNotNull = translate('phoneNotNull');
let Str_EmailNotNull = translate('emailNotNull');
let Str_CodeNotNull = translate('codeNotNull');
let Str_ChangeSuc = translate('changeSuc');
let Str_ChangeFail = translate('changeFail');
let Str_InputOldPsd = translate('inputOldPsd');
let Str_InputNewPsd = translate('inputNewPsd');
let Str_InputNewPsdAgain = translate('inputNewPsdAgain');
let Str_OldPsd = translate('oldPsd');
let Str_NewPsd = translate('newPsd');
let Str_Phone = translate('phone');
let Str_Album = translate('album');
let Str_Camera = translate('camera');
let Str_TakePhoto = translate('takePhoto');
let Str_Videotape = translate('videotape');
let Str_Shot = translate('shot');
let Str_Email = translate('email');
let Str_SetEmail = translate('setEmail');
let Str_UpdateEmail = translate('UpdateEmail');
let Str_ConfirmPsd = translate('confirmPsd');
let Str_ProblemNotNull = translate('problemNotNull');
let Str_AnswerNotNull = translate('answerNotNull');
let Str_CommonLoading = translate('commonLoading');
let Str_UpdatePsdTitle = translate('updatePsd.title');
let Str_UpdatePsdLoading = translate('updatePsd.loading');
let Str_OpenSecurityLoading = translate('openSecurity.loading');
let Str_OpenSecurityTitle = translate('openSecurity.title');
let Str_ThePsd = translate('thePsd');
let Str_Err500 = translate('err500');
let Str_Err1013 = translate('err1013');
let Str_Err1014 = translate('err1014');
let Str_Err1015 = translate('err1015');
let Str_Err400 = translate('err400');

let Str_Mine = translate('mine');
let Str_Wallet = translate('wallet');
let Str_Announcement = translate('announcement');
let Str_AccountSecurity = translate('accountSecurity');
let Str_PrivacySetting = translate('privacySetting');
let Str_OtherSetting = translate('otherSetting');
let Str_Logout = translate('logout');
let Str_ConfirmLogout = translate('confirmLogout');
let Str_Tip = translate('tip');
let Str_CopySuc = translate('copySuc');
let Str_CopyFail = translate('copyFail');
let Str_CopyTip = translate('copyTip');
let Str_ChangeLoginPsd = translate('changeLoginPsd');
let Str_ActivateSecurity = translate('activateSecurity');
let Str_ApplyDelAcc = translate('applyDelAcc');
let Str_DelAccMsg1 = translate('delAccMsg1');
let Str_DelAccTip1 = translate('delAccTip1');
let Str_DelAccTip2 = translate('delAccTip2');
let Str_DelAccTip3 = translate('delAccTip3');
let Str_DelAccTip4 = translate('delAccTip4');
let Str_NextStep = translate('nextStep');
let Str_Help = translate('help');
let Str_AboutApp = translate('aboutApp');
let Str_Version = translate('version');
let Str_SignOut = translate('signOut');
let Str_CleanAllChatMsg = translate('cleanAllChatMsg');
let Str_CleanAllDialogMsg = translate('cleanAllDialogMsg');
let Str_CleanAllDialogLoading = translate('cleanAllDialogLoading');
let Str_CleanSuc = translate('cleanSuc');
let Str_CleanFail = translate('cleanFail');
let Str_ChatMsgIsNull = translate('chatMsgIsNull');
let Str_OpenNotify = translate('openNotify');
let Str_AccountPrivacy = translate('accountPrivacy');
let Str_BlackManager = translate('blackManager');
let Str_SetSendMsgInterval = translate('setSendMsgInterval');
let Str_ApplySuc = translate('applySuc');
let Str_ReportSuc = translate('reportSuc');
let Str_Report = translate('report');
let Str_GroupChat = translate('groupChat');
let Str_SingleChat = translate('singleChat');
let Str_PeopleChoose = translate('peopleChoose');
let Str_SendMsgPlaceholder = translate('sendMsgPlaceholder');
let Str_AddMembers = translate('addMembers');
let Str_Clearing = translate('clearing');
let Str_AlreadyTheGroup = translate('alreadyTheGroup');
let Str_InProhibition = translate('inProhibition');
let Str_Prohibition = translate('prohibition');
let Str_SpeakFrequently = translate('speakFrequently');
let Str_SendFail = translate('sendFail');
let Str_SendSuc = translate('sendSuc');
let Str_NewInvitationJoinGroup = translate('newInvitationJoinGroup');
let Str_ClearChatHistory = translate('clearChatHistory');
let Str_You = translate('you');
let Str_ScanCodeAddGroup = translate('scanCodeAddGroup');
let Str_Invited = translate('invited');
let Str_JoinGroupChat = translate('joinGroupChat');
let Str_Pulling = translate('pulling');
let Str_CreateGroupChat = translate('createGroupChat');
let Str_ExitedGroupChat = translate('exitedGroupChat');
let Str_KickOutGroupChat = translate('kickOutGroupChat');
let Str_Cover = translate('cover');
let Str_YourFriendApproved = translate('yourFriendApproved');
let Str_Img = translate('img');
let Str_Voice = translate('voice');
let Str_Video = translate('video');
let Str_Talk = translate('talk');
let Str_RtcVideo = translate('rtcVideo');
let Str_RtcAudio = translate('rtcAudio');
let Str_WithdrawAMsg = translate('withdrawAMsg');
let Str_MessageForYou = translate('messageForYou');
let Str_ReEdit = translate('reEdit');
let Str_OperationFailed = translate('operationFailed');
let Str_OperationSuc = translate('operationSuc');
let Str_Agree = translate('agree');
let Str_Refuse = translate('refuse');
let Str_GroupApplication = translate('groupApplication');
let Str_SensitiveMsgTip1 = translate('sensitiveMsgTip1');
let Str_SensitiveMsgTip2 = translate('sensitiveMsgTip2');
let Str_Copy = translate('copy');
let Str_Locate = translate('locate');
let Str_CancelTranslate = translate('cancelTranslate');
let Str_Translate = translate('translate');
let Str_TranslateComplete = translate('translateComplete');
let Str_Quote = translate('quote');
let Str_Forward = translate('forward');
let Str_Multi = translate('multi');
let Str_Delete = translate('delete');
let Str_Withdraw = translate('withdraw');
let Str_Speaker = translate('Speaker');
let Str_Receiver = translate('Receiver');
let Str_AddFriends = translate('addFriends');
let Str_Scan = translate('scan');
let Str_Chat = translate('chat');
let Str_Search = translate('search');
let Str_Searching = translate('searching');
let Str_NoticeOpenTip = translate('noticeOpenTip');
let Str_Notice = translate('notice');
let Str_GoOpen = translate('goOpen');
let Str_Send = translate('send');
let Str_SendImage = translate('sendImage');
let Str_Radio = translate('radio');
let Str_CheckBox = translate('checkBox');
let Str_CreateNewSession = translate('createNewSession');
let Str_SelectSessionForwarding = translate('selectSessionForwarding');
let Str_UserDoesNotExist = translate('userDoesNotExist');
let Str_ChatDetail = translate('chatDetail');
let Str_SearchChatContent = translate('searchChatContent');
let Str_ChatTop = translate('chatTop');
let Str_MsgNotification = translate('msgNotification');
let Str_Describe = translate('describe');
let Str_DescribeTip = translate('describeTip');
let Str_DelMember = translate('delMember');
let Str_DelMemberTip = translate('delMemberTip');
let Str_DelMemberTip1 = translate('delMemberTip1');
let Str_ViewAllMembers = translate('viewAllMembers');
let Str_GroupAvatar = translate('groupAvatar');
let Str_GroupQrCode = translate('groupQrCode');
let Str_MyNickname = translate('myNickname');
let Str_GroupAnnouncement = translate('groupAnnouncement');
let Str_GoSetting = translate('goSetting');
let Str_GroupManagement = translate('groupManagement');
let Str_DelGroup = translate('delGroup');
let Str_TransferGroup = translate('transferGroup');
let Str_TransferSuc = translate('transferSuc');
let Str_TransferFail = translate('transferFail');
let Str_AddAdmin = translate('addAdmin');
let Str_RemoveAdmin = translate('removeAdmin');
let Str_GroupEntryReview = translate('groupEntryReview');
let Str_LookGroupList = translate('lookGroupList');
let Str_OpenUser = translate('openUser');
let Str_FriendInviteEnter = translate('friendInviteEnter');
let Str_AllProhibition = translate('allProhibition');
let Str_RemoveProhibition = translate('removeProhibition');
let Str_AllProhibitionTip = translate('allProhibitionTip');
let Str_GroupChatIntervalTime = translate('groupChatIntervalTime');
let Str_Second = translate('second');
let Str_Year = translate('year');
let Str_Month = translate('month');
let Str_Day = translate('day');
let Str_SelectYourBirthday = translate('selectYourBirthday');
let Str_Save = translate('save');
let Str_Yesterday = translate('yesterday');
let Str_BeforeYesterday = translate('beforeYesterday');
let Str_Monday = translate('monday');
let Str_Tuesday = translate('tuesday');
let Str_Wednesday = translate('wednesday');
let Str_Thursday = translate('thursday');
let Str_Friday = translate('friday');
let Str_Saturday = translate('saturday');
let Str_Sunday = translate('sunday');
let Str_GroupMembers = translate('groupMembers');
let Str_SpeakingTimeShort = translate('speakingTimeShort');
let Str_ReleaseFingerUpCancelSending = translate('releaseFingerUpCancelSending');
let Str_FingerUpCancelSending = translate('fingerUpCancelSending');
let Str_HoldTalk = translate('holdTalk');
let Str_Contact = translate('contact');
let Str_NewFriendInvitation = translate('newFriendInvitation');
let Str_ContactFriendTip = translate('contactFriendTip');
let Str_ContactBlackTip = translate('contactBlackTip');
let Str_Contacts = translate('contacts');
let Str_Service = translate('service');
let Str_ThroughVerification = translate('throughVerification');
let Str_SendMsg = translate('sendMsg');
let Str_LoadFail = translate('loadFail');
let Str_SendFriendApply = translate('sendFriendApply');
let Str_QrCodeTip = translate('qrCodeTip');
let Str_DelFriend = translate('delFriend');
let Str_DelFriendTip = translate('delFriendTip');
let Str_AddFriendBlackTip = translate('addFriendBlackTip');
let Str_SettingInformation = translate('settingInformation');
let Str_JoinBlacklist = translate('joinBlacklist');
let Str_Passed = translate('passed');
let Str_See = translate('see');
let Str_NewFriend = translate('newFriend');
let Str_EmailRetrieve = translate('emailRetrieve');
let Str_PhoneRetrieve = translate('phoneRetrieve');
let Str_SecurityRetrieve = translate('securityRetrieve');
let Str_NoData = translate('noData');
let Str_DelChat = translate('delChat');
let Str_QrCodeGroupTip = translate('qrCodeGroupTip');
let Str_CameraPermissionErrorTip = translate('cameraPermissionErrorTip');
let Str_MicPermissionErrorTip = translate('micPermissionErrorTip');
let Str_WriteFilePermissionErrorTip = translate('writeFilePermissionErrorTip');
let Str_AlbumPermissionErrorTip = translate('albumPermissionErrorTip');

let Str_SendTo = translate('sendTo');
let Str_LeaveMessageFriends = translate('leaveMessageFriends');
let Str_Reply = translate('reply');
let Str_SelectChat = translate('selectChat');
let Str_ChatRecord = translate('chatRecord');
let Str_ErrorChatRecord = translate('errorChatRecord');
let Str_CreateNewChat = translate('createNewChat');
let Str_DelFail = translate('delFail');
let Str_GroupChatHistory = translate('groupChatHistory');
let Str_And = translate('and');
let Str_OfChatRecord = translate('ofChatRecord');
let Str_Feedback = translate('feedback');
let Str_FeedbackText1 = translate('feedbackText1');
let Str_FeedbackText2 = translate('feedbackText2');
let Str_FeedbackImgDesc = translate('feedbackImgDesc');
let Str_FeedbackImgText = translate('feedbackImgText');
let Str_FeedbackToast1 = translate('feedbackToast1');
let Str_FeedbackToast2 = translate('feedbackToast2');
let Str_FeedbackToast3 = translate('feedbackToast3');

let Str_FeedbackSuc = translate('feedbackSuc');
let Str_FeedbackFail = translate('feedbackFail');
let Str_FeedbackPlaceholder1 = translate('feedbackPlaceholder1');
let Str_FeedbackPlaceholder2 = translate('feedbackPlaceholder2');

let Str_TopicTop = translate('TopicTop');
let Str_TopicUntop = translate('TopicUntop');
let Str_MarkRead = translate('MarkRead');
let Str_ScannerQRCodeErr = translate('ScannerQRCodeErr');
let Str_FatchUserFailure = translate('FatchUserFailure');
let Str_CreateLabel = translate('CreateLabel');
let Str_CreateAddLabel = translate('CreateAddLabel');
let Str_LabelName = translate('LabelName');
let Str_Label = translate('Label');
let Str_LabelNotNull = translate('LabelNotNull');
let Str_CreateSucc = translate('CreateSucc');
let Str_CreateFail = translate('CreateFail');
let Str_ConstactLabel = translate('ConstactLabel');
let Str_LabelEmpty = translate('LabelEmpty');
let Str_AllLabel = translate('AllLabel');
let Str_SelectOrSearchLabel = translate('SelectOrSearchLabel');
let Str_Add = translate('Add');
let Str_ShiftOut = translate('ShiftOut');
let Str_Deleted = translate('Deleted');
let Str_DeleteFail = translate('DeleteFail');
let Str_DeleteSucc = translate('DeleteSucc');
let Str_AddLabel = translate('AddLabel');
let Str_LabelAlreadyExists = translate('LabelAlreadyExists');
let Str_AddSucc = translate('AddSucc');
let Str_AddFail = translate('AddFail');
let Str_ShiftOutSucc = translate('ShiftOutSucc');
let Str_ShiftOutFail = translate('ShiftOutFail');
let Str_SelectFriend = translate('SelectFriend');
let Str_SelectShiftOutMember = translate('SelectShiftOutMember');
let Str_UpdateLabelName = translate('UpdateLabelName');
let Str_NowLabelMemberEmpty = translate('NowLabelMemberEmpty');
let Str_DeleteLabel = translate('DeleteLabel');
let Str_DeleteLabelTip = translate('DeleteLabelTip');
let Str_SaveSucc = translate('SaveSucc');
let Str_QRCodeError = translate('QRCodeError');
let Str_SavePicture = translate('SavePicture');
let Str_ApplyJoinGroup = translate('ApplyJoinGroup');
let Str_JoinGroupPlace = translate('JoinGroupPlace');
let Str_SelectDate = translate('SelectDate');
let Str_NewMsgCount = translate('NewMsgCount');
let Str_Collect = translate('Collect');
let Str_Draft = translate('Draft');
let Str_MoreContacts = translate('MoreContacts');
let Str_Include = translate('Include');
let Str_MoreGroupChats = translate('MoreGroupChats');
let Str_RelatedChatRecords = translate('RelatedChatRecords');
let Str_MoreChatRecord = translate('MoreChatRecord');
let Str_AddEmoticons = translate('AddEmoticons');
let Str_OnlyGroupAdminCanEdit = translate('OnlyGroupAdminCanEdit');
let Str_AnnouncementNotEmpty = translate('AnnouncementNotEmpty');
let Str_AccordingTo = translate('AccordingTo');
let Str_Find = translate('Find');
let Str_Member = translate('Member');
let Str_Date = translate('Date');
let Str_AccordingToDateFind = translate('AccordingToDateFind');
let Str_QuickSearchMsgContent = translate('QuickSearchMsgContent');
let Str_ReadCount = translate('ReadCount');
let Str_Emit = translate('Emit');
let Str_MyQRCode = translate('MyQRCode');
let Str_GroupNameNotNull = translate('groupNameNotNull');
let Str_Edit = translate('Edit');
let Str_AddAddedSingleEmoticon = translate('AddAddedSingleEmoticon');
let Str_Tidy = translate('tidy');
let Str_ClearCache = translate('ClearCache');
let Str_LanguageSwitching = translate('LanguageSwitching');
let Str_AlreadyRegistered = translate('AlreadyRegistered');
let Str_AlreadyUsed = translate('AlreadyUsed');
let Str_AlreadyNotRegistered = translate('AlreadyNotRegistered');
let Str_AlreadyBoundPhone = translate('AlreadyBoundPhone');
let Str_NotInGroup = translate('NotInGroup');
let Str_NotInGroup_NotSend = translate('NotInGroup_NotSend');
let Str_No_images = translate('no_images');
let Str_No_videos = translate('no_videos');
let Str_No_documents = translate('no_documents');
let Str_Group_owner = translate('group_owner');
let Str_Admin = translate('admin');
let Str_Group_no_images = translate('group_no_images');
let Str_Group_no_videos = translate('group_no_videos');
let Str_Group_no_documents = translate('group_no_documents');
let Str_Forward_image_warning = translate('forward_image_warning');
let Str_Forward_video_warning = translate('forward_video_warning');
let Str_Forward_document_warning = translate('forward_document_warning');
let Str_Admin_bold_font = translate('admin_bold_font');
let Str_Admin_text_color = translate('admin_text_color');
let Str_Special_message = translate('special_message');
let Str_Reject = translate('reject');
let Str_Rejected = translate('rejected');
let Str_Canceled = translate('canceled');
let Str_Unanswered = translate('Unanswered');
let Str_OtherEndRejected = translate('OtherEndRejected');
let Str_OtherEndCanceled = translate('OtherEndCanceled');
let Str_OtherEndUnanswered = translate('OtherEndUnanswered');
let Str_GroupDisbanded = translate('groupDisbanded');
let Str_loginGuide = translate('loginGuide');
let Str_accountBindingNotice = translate('accountBindingNotice');
let Str_dontRemind = translate('dontRemind');
let Str_confirmChange = translate('confirmChange');
let Str_identityHint = translate('identityHint');
let Str_setNickname = translate('setNickname');
let Str_RetrievePsd = translate('RetrievePsd');
let Str_customerService = translate('customerService');
let Str_RetrievePsdpPaceholder = translate('RetrievePsdpPaceholder');
let Str_usernameMismatch = translate('usernameMismatch');
let Str_enterCaptcha = translate('enterCaptcha');
let Str_captchaError = translate('captchaError');
let Str_unknownError = translate('unknownError');
let Str_noRecoveryMethod = translate('noRecoveryMethod');
let Str_PasswordCannotBeSame = translate('PasswordCannotBeSame');
let Str_InviteCode = translate('InviteCode');
let Str_NoSpacesAllowed = translate('NoSpacesAllowed');
let Str_featureTitle_1 = translate('featureTitle_1');
let Str_featureTitle_2 = translate('featureTitle_2');
let Str_featureTitle_3 = translate('featureTitle_3');
let Str_featureSubTitle_1 = translate('featureSubTitle_1');
let Str_featureSubTitle_2 = translate('featureSubTitle_2');
let Str_featureSubTitle_3 = translate('featureSubTitle_3');
let Str_Experience = translate('Experience');
let Str_openPrivateChat = translate('openPrivateChat');
let Str_LoginConfirm = translate('LoginConfirm');
let Str_LoginConfirmTip = translate('LoginConfirmTip');
let Str_QRCodeInvalid = translate('QRCodeInvalid');
let Str_FileSizeLimit = translate('fileSizeLimit');
let Str_CanNoFindMsg = translate('CanNoFindMsg');
let Str_ContactDeleted = translate('ContactDeleted');
let Str_FindNewVersion = translate('FindNewVersion');
let Str_UpdateNow = translate('UpdateNow');
let Str_UpdateLater = translate('UpdateLater');
let Str_MsgLoading = translate('MsgLoading');
let Str_UnbindEmailError = translate('UnbindEmailError');
let Str_Refresh = translate('Refresh');
let Str_BehavioralVerify = translate('BehavioralVerify');
let Str_BehavioralVerifyTip = translate('BehavioralVerifyTip');
let Str_UpdateAvatar = translate('UpdateAvatar');
let Str_Myself = translate('Myself');
let Str_Friends = translate('Friends');
let Str_Moments = translate('Moments');
let Str_Publish = translate('Publish');
let Str_Publishing = translate('Publishing');
let Str_PublishContentNotEmpty = translate('PublishContentNotEmpty');
let Str_PublishSuccess = translate('PublishSuccess');
let Str_PublishFail = translate('PublishFail');
let Str_SaySomething = translate('SaySomething');
let Str_SupportContent = translate('SupportContent');
let Str_MaxLimit = translate('MaxLimit');
let Str_HadCancelAuthorize = translate('HadCancelAuthorize');
let Str_HadChangeAccount = translate('HadChangeAccount');
let Str_AuthorizeHadExpired = translate('AuthorizeHadExpired');
let Str_LogOutCurrentAccount = translate('LogOutCurrentAccount');
let Str_LogOutAllAccount = translate('LogOutAllAccount');
let Str_NoSupportFileType = translate('NoSupportFileType');
let Str_File = translate('File');
let Str_Reload = translate('Reload');
let Str_MaxFileCountLimit = translate('MaxFileCountLimit');
let Str_FrequentTips = translate('FrequentTips');
let Str_AccountHadLoginThisDevice = translate('AccountHadLoginThisDevice');


// 更新翻译字段的函数
export const updateTranslations = () => {
	Str_Myself = translate('Myself');
	Str_Friends = translate('Friends');
	Str_Moments = translate('Moments');
	Str_Publish = translate('Publish');
	Str_Publishing = translate('Publishing');
	Str_PublishContentNotEmpty = translate('PublishContentNotEmpty');
	Str_PublishSuccess = translate('PublishSuccess');
	Str_PublishFail = translate('PublishFail');
	Str_SaySomething = translate('SaySomething');
	Str_SupportContent = translate('SupportContent');
	Str_MaxLimit = translate('MaxLimit');
	Str_RtcVideo = translate('rtcVideo');
	Str_ContactDeleted = translate('ContactDeleted');
	Str_RtcAudio = translate('rtcAudio');
	Str_LoginConfirm = translate('LoginConfirm');
	Str_LoginConfirmTip = translate('LoginConfirmTip');
	Str_QRCodeInvalid = translate('QRCodeInvalid');
	Str_FileSizeLimit = translate('fileSizeLimit');
	Str_CanNoFindMsg = translate('CanNoFindMsg');
	Str_usernameMismatch = translate('usernameMismatch');
	Str_enterCaptcha = translate('enterCaptcha');
	Str_captchaError = translate('captchaError');
	Str_unknownError = translate('unknownError');
	Str_noRecoveryMethod = translate('noRecoveryMethod');
	Str_RetrievePsd = translate('RetrievePsd');
	Str_customerService = translate('customerService');
	Str_RetrievePsdpPaceholder = translate('RetrievePsdpPaceholder');
	Str_loginGuide = translate('loginGuide');
	Str_accountBindingNotice = translate('accountBindingNotice');
	Str_dontRemind = translate('dontRemind');
	Str_confirmChange = translate('confirmChange');
	Str_identityHint = translate('identityHint');
	Str_setNickname = translate('setNickname');
	Str_MemberModifyGroupNickname = translate('groupMemberModifyGroupNickname');
	Str_MemberSendImage = translate('groupMemberSendImage');
	Str_MemberJoinGroupMessage = translate('groupMemberJoinGroupMessage');
	Str_MemberLeaveGroupMessage = translate('groupMemberLeaveGroupMessage');
	Str_MemberSendVideo = translate('groupMemberSendVideo');
	Str_MemberSendDocument = translate('groupMemberSendDocument');
	Str_SetFontStyle = translate('setFontStyle');
	Str_GroupDisbanded = translate('groupDisbanded');
	Str_SelectCountryRegion = translate('selectCountryRegion');
	Str_Reject = translate('reject');
	Str_Rejected = translate('rejected');
	Str_Canceled = translate('canceled');
	Str_Unanswered = translate('Unanswered');
	Str_OtherEndRejected = translate('OtherEndRejected');
	Str_OtherEndCanceled = translate('OtherEndCanceled');
	Str_OtherEndUnanswered = translate('OtherEndUnanswered');
	Str_Special_message = translate('special_message');
	Str_DelAndClean = translate('DelAndClean');
	Str_TingTongText = translate('TingTongText');
	Str_ClickQuery = translate('ClickQuery');
	Str_QueryFail = translate('QueryFail');
	Str_NetworkConnectFail = translate('NetworkConnectFail');
	Str_GroupApplyTip = translate('groupApplyTip');
	Str_NotInGroup = translate('NotInGroup');
	Str_NotInGroup_NotSend = translate('NotInGroup_NotSend');
	Str_NoSupportFileType = translate('NoSupportFileType');
	Str_GroupMessaging = translate('GroupMessaging');
	Str_InputGroupContent = translate('InputGroupContent');
	Str_SelectAll = translate('selectAll');
	Str_UnSelectAll = translate('unSelectAll');
	Str_MassSendingAssistant = translate('MassSendingAssistant');
	Str_CreatTopicErr = translate('CreatTopicErr');
	Str_SendComplete = translate('SendComplete');
	Str_EmptyNotSend = translate('EmptyNotSend');
	Str_CurrenAccInUse = translate('currenAccInUse');
	Str_AccDelTip = translate('AccDelTip');
	Str_SwitchAccSuc = translate('switchAccSuc');
	Str_SwitchAccTip = translate('switchAccTip');
	Str_Clear = translate('Clear');
	Str_NowUse = translate('NowUse');
	Str_Manage = translate('Manage');
	Str_AddAccount = translate('AddAccount');
	Str_ScannerPictureError = translate('ScannerPictureError');
	Str_SwitchAccount = translate('SwitchAccount');
	Str_ReadAgreed = translate('readAgreed');
	Str_ReadAgreedTip = translate('readAgreedTip');
	Str_UserAgreement = translate('UserAgreement');
	Str_PrivacyPolicy = translate('PrivacyPolicy');
	Str_AddFriendTip = translate('AddFriendTip');
	Str_AccountLogin = translate('accountLogin');
	Str_PhoneLogin = translate('phoneLogin');
	Str_AlreadyBoundPhone = translate('AlreadyBoundPhone');
	Str_AlreadyRegistered = translate('AlreadyRegistered');
	Str_AlreadyUsed = translate('AlreadyUsed');
	Str_AlreadyNotRegistered = translate('AlreadyNotRegistered');
	Str_Confirm = translate('confirm');
	Str_Skip = translate('skip');
	Str_Cancel = translate('cancel');
	Str_Complete = translate('complete');
	Str_ReSend = translate('reSend');
	Str_CodeAlreadySend = translate('codeAlreadySend');
	Str_SendCode = translate('sendCode');
	Str_Code = translate('code');
	Str_CodeSendFail = translate('codeSendFail');
	Str_ForgotPsd = translate('forgotPsd');
	Str_RememberPsd = translate('rememberPsd');
	Str_Register = translate('register');
	Str_LoginRegister = translate('loginRegister');
	Str_LoginByCode = translate('loginByCode');
	Str_LoginByPsd = translate('loginByPsd');
	Str_LoginNow = translate('loginNow');
	Str_NotSet = translate('notSet');
	Str_Avatar = translate('avatar');
	Str_Account = translate('account');
	Str_Nick = translate('nick');
	Str_Telno = translate('telno');
	Str_SetTelno = translate('setTelno');
	Str_UpdateTelno = translate('UpdateTelno');
	Str_InputTelno = translate('inputTelno');
	Str_Sex = translate('sex');
	Str_Man = translate('man');
	Str_Woman = translate('woman');
	Str_NotDisclose = translate('notDisclose');
	Str_SetSex = translate('setSex');
	Str_InputSex = translate('inputSex');
	Str_Remarks = translate('remarks');
	Str_SetRemarks = translate('setRemarks');
	Str_InputRemarks = translate('inputRemarks');
	Str_GroupName = translate('groupName');
	Str_SetGroupName = translate('setGroupName');
	Str_InputGroupName = translate('inputGroupName');
	Str_GroupNotice = translate('groupNotice');
	Str_SetGroupNotice = translate('setGroupNotice');
	Str_InputGroupNotice = translate('inputGroupNotice');
	Str_GroupNick = translate('groupNick');
	Str_SetNick = translate('setNick');
	Str_ToVerify = translate('toVerify');
	Str_PersonalInfo = translate('personalInfo');
	Str_Birthday = translate('birthday');
	Str_ImgUploading = translate('imgUploading');
	Str_ImgUploadFail = translate('imgUploadFail');
	Str_ScannerEnter = translate('scannerEnter');
	Str_ServiceNumberCommonErr = translate('serviceNumber.commonErr');
	Str_ServiceNumberCommonErr1 = translate('serviceNumber.commonErr1');
	Str_ServiceNumberCommonErr2 = translate('serviceNumber.commonErr2');
	Str_ServiceNumberInputHint = translate('serviceNumber.inputHint');
	Str_LoginLoading = translate('login.loginTip');
	Str_SwitchUserFail = translate('switchUserFail');
	Str_NickNotNull = translate('nickNotNull');
	Str_AccFormatErr = translate('accFormatErr');
	Str_AccNotNull = translate('accNotNull');
	Str_PsdNotNull = translate('psdNotNull');
	Str_PsdNotEmpty = translate('psdNotEmpty');
	Str_PsdOldNotNull = translate('psdOldNotNull');
	Str_PsdLengthErr1 = translate('psdLengthErr1');
	Str_PsdLengthErr2 = translate('psdLengthErr2');
	Str_PsdOldLengthErr1 = translate('psdOldLengthErr1');
	Str_PsdOldLengthErr2 = translate('psdOldLengthErr2');
	Str_PsdFormatErr = translate('psdFormatErr');
	Str_LogoutErr = translate('logoutErr');

	Str_PsdInconsistent = translate('psdInconsistent');
	Str_PhoneFormatErr = translate('phoneFormatErr');
	Str_EmailFormatErr = translate('emailFormatErr');
	Str_Registering = translate('registering');
	Str_RegisterSuc = translate('registerSuc');
	Str_RegisterFail = translate('registerFail');
	Str_InputNick = translate('inputNick');
	Str_InputAcc = translate('inputAcc');
	Str_InputAcc2 = translate('inputAcc2');
	Str_InputAcc3 = translate('inputAcc3');
	Str_InputAcAgain = translate('inputAcAgain');
	Str_InputCode = translate('inputCode');
	Str_InputPhone = translate('inputPhone');
	Str_InputEmail = translate('inputEmail');
	Str_InputPsd = translate('inputPsd');
	Str_InputPsdAgain = translate('inputPsdAgain');
	Str_InputProblem = translate('inputProblem');
	Str_InputAnswer = translate('inputAnswer');
	Str_HasAcc = translate('hasAcc');
	Str_Binding = translate('binding');
	Str_BindSuc = translate('bindSuc');
	Str_BindFail = translate('bindFail');
	Str_BindPhone = translate('bindPhone');
	Str_BindEmail = translate('bindEmail');
	Str_PlaceholderPsd = translate('placeholderPsd');
	Str_PlaceholderProblem = translate('placeholderProblem');
	Str_PlaceholderAnswer = translate('placeholderAnswer');
	Str_SetSuc = translate('setSuc');
	Str_SetFail = translate('setFail');
	Str_Psd = translate('psd');
	Str_Problem = translate('problem');
	Str_Answer = translate('answer');
	Str_PhoneNotNull = translate('phoneNotNull');
	Str_EmailNotNull = translate('emailNotNull');
	Str_CodeNotNull = translate('codeNotNull');
	Str_ChangeSuc = translate('changeSuc');
	Str_ChangeFail = translate('changeFail');
	Str_InputOldPsd = translate('inputOldPsd');
	Str_InputNewPsd = translate('inputNewPsd');
	Str_InputNewPsdAgain = translate('inputNewPsdAgain');
	Str_OldPsd = translate('oldPsd');
	Str_NewPsd = translate('newPsd');
	Str_Phone = translate('phone');
	Str_Album = translate('album');
	Str_Camera = translate('camera');
	Str_TakePhoto = translate('takePhoto');
	Str_Videotape = translate('videotape');
	Str_Shot = translate('shot');
	Str_Email = translate('email');
	Str_SetEmail = translate('setEmail');
	Str_UpdateEmail = translate('UpdateEmail');

	Str_ConfirmPsd = translate('confirmPsd');
	Str_ProblemNotNull = translate('problemNotNull');
	Str_AnswerNotNull = translate('answerNotNull');
	Str_CommonLoading = translate('commonLoading');
	Str_UpdatePsdTitle = translate('updatePsd.title');
	Str_UpdatePsdLoading = translate('updatePsd.loading');
	Str_OpenSecurityLoading = translate('openSecurity.loading');
	Str_OpenSecurityTitle = translate('openSecurity.title');
	Str_ThePsd = translate('thePsd');
	Str_Err500 = translate('err500');
	Str_Err1013 = translate('err1013');
	Str_Err1014 = translate('err1014');
	Str_Err1015 = translate('err1015');
	Str_Err400 = translate('err400');

	Str_Mine = translate('mine');
	Str_Wallet = translate('wallet');
	Str_Announcement = translate('announcement');
	Str_AccountSecurity = translate('accountSecurity');
	Str_PrivacySetting = translate('privacySetting');
	Str_OtherSetting = translate('otherSetting');
	Str_Logout = translate('logout');
	Str_ConfirmLogout = translate('confirmLogout');
	Str_Tip = translate('tip');
	Str_CopySuc = translate('copySuc');
	Str_CopyFail = translate('copyFail');
	Str_CopyTip = translate('copyTip');

	Str_ChangeLoginPsd = translate('changeLoginPsd');
	Str_ActivateSecurity = translate('activateSecurity');
	Str_ApplyDelAcc = translate('applyDelAcc');
	Str_DelAccMsg1 = translate('delAccMsg1');
	Str_DelAccTip1 = translate('delAccTip1');
	Str_DelAccTip2 = translate('delAccTip2');
	Str_DelAccTip3 = translate('delAccTip3');
	Str_DelAccTip4 = translate('delAccTip4');
	Str_NextStep = translate('nextStep');
	Str_Help = translate('help');
	Str_AboutApp = translate('aboutApp');
	Str_Version = translate('version');
	Str_SignOut = translate('signOut');
	Str_CleanAllChatMsg = translate('cleanAllChatMsg');
	Str_CleanAllDialogMsg = translate('cleanAllDialogMsg');
	Str_CleanAllDialogLoading = translate('cleanAllDialogLoading');
	Str_CleanSuc = translate('cleanSuc');
	Str_CleanFail = translate('cleanFail');
	Str_ChatMsgIsNull = translate('chatMsgIsNull');
	Str_OpenNotify = translate('openNotify');
	Str_AccountPrivacy = translate('accountPrivacy');
	Str_BlackManager = translate('blackManager');
	Str_SetSendMsgInterval = translate('setSendMsgInterval');
	Str_ApplySuc = translate('applySuc');
	Str_ReportSuc = translate('reportSuc');
	Str_Report = translate('report');
	Str_GroupChat = translate('groupChat');
	Str_SingleChat = translate('singleChat');
	Str_PeopleChoose = translate('peopleChoose');
	Str_SendMsgPlaceholder = translate('sendMsgPlaceholder');
	Str_AddMembers = translate('addMembers');
	Str_Clearing = translate('clearing');
	Str_AlreadyTheGroup = translate('alreadyTheGroup');
	Str_InProhibition = translate('inProhibition');
	Str_Prohibition = translate('prohibition');
	Str_SpeakFrequently = translate('speakFrequently');
	Str_SendFail = translate('sendFail');
	Str_SendSuc = translate('sendSuc');
	Str_NewInvitationJoinGroup = translate('newInvitationJoinGroup');
	Str_ClearChatHistory = translate('clearChatHistory');
	Str_You = translate('you');
	Str_ScanCodeAddGroup = translate('scanCodeAddGroup');
	Str_Invited = translate('invited');
	Str_JoinGroupChat = translate('joinGroupChat');
	Str_Pulling = translate('pulling');
	Str_CreateGroupChat = translate('createGroupChat');
	Str_ExitedGroupChat = translate('exitedGroupChat');
	Str_KickOutGroupChat = translate('kickOutGroupChat');
	Str_Cover = translate('cover');
	Str_YourFriendApproved = translate('yourFriendApproved');
	Str_Img = translate('img');
	Str_Voice = translate('voice');
	Str_Video = translate('video');
	Str_Talk = translate('talk');
	Str_WithdrawAMsg = translate('withdrawAMsg');
	Str_MessageForYou = translate('messageForYou');
	Str_ReEdit = translate('reEdit');
	Str_OperationFailed = translate('operationFailed');
	Str_OperationSuc = translate('operationSuc');
	Str_Agree = translate('agree');
	Str_Refuse = translate('refuse');
	Str_GroupApplication = translate('groupApplication');
	Str_SensitiveMsgTip1 = translate('sensitiveMsgTip1');
	Str_SensitiveMsgTip2 = translate('sensitiveMsgTip2');
	Str_Copy = translate('copy');
	Str_Locate = translate('locate');
	Str_Translate = translate('translate');
	Str_CancelTranslate = translate('cancelTranslate');
	Str_TranslateComplete = translate('translateComplete');
	Str_Quote = translate('quote');
	Str_Forward = translate('forward');
	Str_Multi = translate('multi');
	Str_Delete = translate('delete');
	Str_Withdraw = translate('withdraw');
	Str_Speaker = translate('Speaker');
	Str_Receiver = translate('Receiver');
	Str_AddFriends = translate('addFriends');
	Str_Scan = translate('scan');
	Str_Chat = translate('chat');
	Str_Search = translate('search');
	Str_Searching = translate('searching');
	Str_NoticeOpenTip = translate('noticeOpenTip');
	Str_Notice = translate('notice');
	Str_GoOpen = translate('goOpen');
	Str_Send = translate('send');
	Str_SendImage = translate('sendImage');
	Str_Radio = translate('radio');
	Str_CheckBox = translate('checkBox');
	Str_CreateNewSession = translate('createNewSession');
	Str_SelectSessionForwarding = translate('selectSessionForwarding');
	Str_UserDoesNotExist = translate('userDoesNotExist');
	Str_ChatDetail = translate('chatDetail');
	Str_SearchChatContent = translate('searchChatContent');
	Str_ChatTop = translate('chatTop');
	Str_MsgNotification = translate('msgNotification');
	Str_Describe = translate('describe');
	Str_DescribeTip = translate('describeTip');
	Str_DelMember = translate('delMember');
	Str_DelMemberTip = translate('delMemberTip');
	Str_DelMemberTip1 = translate('delMemberTip1');
	Str_ViewAllMembers = translate('viewAllMembers');
	Str_GroupAvatar = translate('groupAvatar');
	Str_GroupQrCode = translate('groupQrCode');
	Str_MyNickname = translate('myNickname');
	Str_GroupAnnouncement = translate('groupAnnouncement');
	Str_GoSetting = translate('goSetting');
	Str_GroupManagement = translate('groupManagement');
	Str_DelGroup = translate('delGroup');
	Str_TransferGroup = translate('transferGroup');
	Str_TransferSuc = translate('transferSuc');
	Str_TransferFail = translate('transferFail');
	Str_AddAdmin = translate('addAdmin');
	Str_RemoveAdmin = translate('removeAdmin');
	Str_GroupEntryReview = translate('groupEntryReview');
	Str_LookGroupList = translate('lookGroupList');
	Str_OpenUser = translate('openUser');
	Str_FriendInviteEnter = translate('friendInviteEnter');
	Str_AllProhibition = translate('allProhibition');
	Str_RemoveProhibition = translate('removeProhibition');
	Str_AllProhibitionTip = translate('allProhibitionTip');
	Str_GroupChatIntervalTime = translate('groupChatIntervalTime');
	Str_Second = translate('second');
	Str_Year = translate('year');
	Str_Month = translate('month');
	Str_Day = translate('day');
	Str_SelectYourBirthday = translate('selectYourBirthday');
	Str_Save = translate('save');
	Str_Yesterday = translate('yesterday');
	Str_BeforeYesterday = translate('beforeYesterday');
	Str_Monday = translate('monday');
	Str_Tuesday = translate('tuesday');
	Str_Wednesday = translate('wednesday');
	Str_Thursday = translate('thursday');
	Str_Friday = translate('friday');
	Str_Saturday = translate('saturday');
	Str_Sunday = translate('sunday');
	Str_GroupMembers = translate('groupMembers');
	Str_SpeakingTimeShort = translate('speakingTimeShort');
	Str_ReleaseFingerUpCancelSending = translate('releaseFingerUpCancelSending');
	Str_FingerUpCancelSending = translate('fingerUpCancelSending');
	Str_HoldTalk = translate('holdTalk');
	Str_Contact = translate('contact');
	Str_NewFriendInvitation = translate('newFriendInvitation');
	Str_ContactFriendTip = translate('contactFriendTip');
	Str_ContactBlackTip = translate('contactBlackTip');
	Str_Contacts = translate('contacts');
	Str_Service = translate('service');
	Str_ThroughVerification = translate('throughVerification');
	Str_SendMsg = translate('sendMsg');
	Str_LoadFail = translate('loadFail');
	Str_SendFriendApply = translate('sendFriendApply');
	Str_QrCodeTip = translate('qrCodeTip');
	Str_DelFriend = translate('delFriend');
	Str_DelFriendTip = translate('delFriendTip');
	Str_AddFriendBlackTip = translate('addFriendBlackTip');
	Str_SettingInformation = translate('settingInformation');
	Str_JoinBlacklist = translate('joinBlacklist');
	Str_Passed = translate('passed');
	Str_See = translate('see');
	Str_NewFriend = translate('newFriend');
	Str_EmailRetrieve = translate('emailRetrieve');
	Str_PhoneRetrieve = translate('phoneRetrieve');
	Str_SecurityRetrieve = translate('securityRetrieve');
	Str_NoData = translate('noData');
	Str_DelChat = translate('delChat');
	Str_QrCodeGroupTip = translate('qrCodeGroupTip');
	Str_CameraPermissionErrorTip = translate('cameraPermissionErrorTip');
	Str_MicPermissionErrorTip = translate('micPermissionErrorTip');
	Str_WriteFilePermissionErrorTip = translate('writeFilePermissionErrorTip');
	Str_AlbumPermissionErrorTip = translate('albumPermissionErrorTip');

	Str_SendTo = translate('sendTo');
	Str_LeaveMessageFriends = translate('leaveMessageFriends');
	Str_Reply = translate('reply');
	Str_SelectChat = translate('selectChat');
	Str_ChatRecord = translate('chatRecord');
	Str_ErrorChatRecord = translate('errorChatRecord');
	Str_CreateNewChat = translate('createNewChat');
	Str_DelFail = translate('delFail');
	Str_GroupChatHistory = translate('groupChatHistory');
	Str_And = translate('and');
	Str_OfChatRecord = translate('ofChatRecord');
	Str_Feedback = translate('feedback');
	Str_FeedbackText1 = translate('feedbackText1');
	Str_FeedbackText2 = translate('feedbackText2');
	Str_FeedbackImgDesc = translate('feedbackImgDesc');
	Str_FeedbackImgText = translate('feedbackImgText');
	Str_FeedbackToast1 = translate('feedbackToast1');
	Str_FeedbackToast2 = translate('feedbackToast2');
	Str_FeedbackToast3 = translate('feedbackToast3');
	Str_FeedbackSuc = translate('feedbackSuc');
	Str_FeedbackFail = translate('feedbackFail');
	Str_FeedbackPlaceholder1 = translate('feedbackPlaceholder1');
	Str_FeedbackPlaceholder2 = translate('feedbackPlaceholder2');

	Str_TopicTop = translate('TopicTop');
	Str_TopicUntop = translate('TopicUntop');
	Str_MarkRead = translate('MarkRead');
	Str_ScannerQRCodeErr = translate('ScannerQRCodeErr');
	Str_FatchUserFailure = translate('FatchUserFailure');
	Str_CreateLabel = translate('CreateLabel');
	Str_CreateAddLabel = translate('CreateAddLabel');
	Str_LabelName = translate('LabelName');
	Str_Label = translate('Label');
	Str_LabelNotNull = translate('LabelNotNull');
	Str_CreateSucc = translate('CreateSucc');
	Str_CreateFail = translate('CreateFail');
	Str_ConstactLabel = translate('ConstactLabel');
	Str_LabelEmpty = translate('LabelEmpty');
	Str_AllLabel = translate('AllLabel');
	Str_SelectOrSearchLabel = translate('SelectOrSearchLabel');
	Str_Add = translate('Add');
	Str_ShiftOut = translate('ShiftOut');
	Str_Deleted = translate('Deleted');
	Str_DeleteFail = translate('DeleteFail');
	Str_DeleteSucc = translate('DeleteSucc');
	Str_AddLabel = translate('AddLabel');
	Str_LabelAlreadyExists = translate('LabelAlreadyExists');
	Str_AddSucc = translate('AddSucc');
	Str_AddFail = translate('AddFail');
	Str_ShiftOutSucc = translate('ShiftOutSucc');
	Str_ShiftOutFail = translate('ShiftOutFail');
	Str_SelectFriend = translate('SelectFriend');
	Str_SelectShiftOutMember = translate('SelectShiftOutMember');
	Str_UpdateLabelName = translate('UpdateLabelName');
	Str_NowLabelMemberEmpty = translate('NowLabelMemberEmpty');
	Str_DeleteLabel = translate('DeleteLabel');
	Str_DeleteLabelTip = translate('DeleteLabelTip');
	Str_SaveSucc = translate('SaveSucc');
	Str_QRCodeError = translate('QRCodeError');
	Str_SavePicture = translate('SavePicture');
	Str_ApplyJoinGroup = translate('ApplyJoinGroup');
	Str_JoinGroupPlace = translate('JoinGroupPlace');
	Str_SelectDate = translate('SelectDate');
	Str_NewMsgCount = translate('NewMsgCount');
	Str_Collect = translate('Collect');
	Str_Draft = translate('Draft');
	Str_MoreContacts = translate('MoreContacts');
	Str_Include = translate('Include');
	Str_MoreGroupChats = translate('MoreGroupChats');
	Str_RelatedChatRecords = translate('RelatedChatRecords');
	Str_MoreChatRecord = translate('MoreChatRecord');
	Str_AddEmoticons = translate('AddEmoticons');
	Str_OnlyGroupAdminCanEdit = translate('OnlyGroupAdminCanEdit');
	Str_AnnouncementNotEmpty = translate('AnnouncementNotEmpty');
	Str_AccordingTo = translate('AccordingTo');
	Str_Find = translate('Find');
	Str_Member = translate('Member');
	Str_Date = translate('Date');
	Str_AccordingToDateFind = translate('AccordingToDateFind');
	Str_QuickSearchMsgContent = translate('QuickSearchMsgContent');
	Str_ReadCount = translate('ReadCount');
	Str_Emit = translate('Emit');
	Str_MyQRCode = translate('MyQRCode');
	Str_GroupNameNotNull = translate('groupNameNotNull');
	Str_Edit = translate('Edit');
	Str_AddAddedSingleEmoticon = translate('AddAddedSingleEmoticon');
	Str_Tidy = translate('tidy');
	Str_ClearCache = translate('ClearCache');
	Str_LanguageSwitching = translate('LanguageSwitching');

	Str_No_images = translate('no_images');
	Str_No_videos = translate('no_videos');
	Str_No_documents = translate('no_documents');
	Str_Group_owner = translate('group_owner');
	Str_Admin = translate('admin');
	Str_Group_no_images = translate('group_no_images');
	Str_Group_no_videos = translate('group_no_videos');
	Str_Group_no_documents = translate('group_no_documents');
	Str_Forward_image_warning = translate('forward_image_warning');
	Str_Forward_video_warning = translate('forward_video_warning');
	Str_Forward_document_warning = translate('forward_document_warning');
	Str_Admin_bold_font = translate('admin_bold_font');
	Str_Admin_text_color = translate('admin_text_color');
	Str_PasswordCannotBeSame = translate('PasswordCannotBeSame');
	Str_InviteCode = translate('InviteCode');
	Str_NoSpacesAllowed = translate('NoSpacesAllowed');
	Str_featureTitle_1 = translate('featureTitle_1');
	Str_featureTitle_2 = translate('featureTitle_2');
	Str_featureTitle_3 = translate('featureTitle_3');
	Str_featureSubTitle_1 = translate('featureSubTitle_1');
	Str_featureSubTitle_2 = translate('featureSubTitle_2');
	Str_featureSubTitle_3 = translate('featureSubTitle_3');
	Str_Experience = translate('Experience');
	Str_openPrivateChat = translate('openPrivateChat');
	Str_FindNewVersion = translate('FindNewVersion');
	Str_UpdateNow = translate('UpdateNow');
	Str_UpdateLater = translate('UpdateLater');
	Str_MsgLoading = translate('MsgLoading');
	Str_UnbindEmailError = translate('UnbindEmailError');
	Str_Refresh = translate('Refresh');
	Str_BehavioralVerify = translate('BehavioralVerify');
	Str_BehavioralVerifyTip = translate('BehavioralVerifyTip');
	Str_UpdateAvatar = translate('UpdateAvatar');
	Str_HadCancelAuthorize = translate('HadCancelAuthorize');
	Str_HadChangeAccount = translate('HadChangeAccount');
	Str_AuthorizeHadExpired = translate('AuthorizeHadExpired');
	Str_LogOutCurrentAccount = translate('LogOutCurrentAccount');
	Str_LogOutAllAccount = translate('LogOutAllAccount');
	Str_File = translate('File');
	Str_Reload = translate('Reload');
	Str_MaxFileCountLimit = translate('MaxFileCountLimit');
	Str_FrequentTips = translate('FrequentTips');
	Str_AccountHadLoginThisDevice = translate('AccountHadLoginThisDevice');
};

i18n.on('languageChanged', () => {
	updateTranslations();
});

export {
	Str_NoSupportFileType,
	Str_File,
	Str_RtcVideo,
	Str_RtcAudio,
	Str_PasswordCannotBeSame,
	Str_NoSpacesAllowed,
	Str_InviteCode,
	Str_MemberModifyGroupNickname,
	Str_MemberSendImage,
	Str_MemberJoinGroupMessage,
	Str_MemberLeaveGroupMessage,
	Str_MemberSendVideo,
	Str_MemberSendDocument,
	Str_SetFontStyle,
	Str_GroupDisbanded,
	Str_SelectCountryRegion,
	Str_DelAndClean,
	Str_TingTongText,
	Str_ClickQuery,
	Str_QueryFail,
	Str_NetworkConnectFail,
	Str_NotInGroup,
	Str_NotInGroup_NotSend,
	Str_Confirm,
	Str_Skip,
	Str_Cancel,
	Str_Complete,
	Str_ReSend,
	Str_CodeAlreadySend,
	Str_SendCode,
	Str_Code,
	Str_CodeSendFail,
	Str_ForgotPsd,
	Str_RememberPsd,
	Str_Register,
	Str_LoginRegister,
	Str_LoginByCode,
	Str_LoginByPsd,
	Str_LoginNow,
	Str_NotSet,
	Str_Avatar,
	Str_Account,
	Str_Nick,
	Str_Telno,
	Str_SetTelno,
	Str_UpdateTelno,
	Str_InputTelno,
	Str_Sex,
	Str_Man,
	Str_Woman,
	Str_NotDisclose,
	Str_SetSex,
	Str_InputSex,
	Str_Remarks,
	Str_SetRemarks,
	Str_InputRemarks,
	Str_GroupName,
	Str_SetGroupName,
	Str_InputGroupName,
	Str_GroupNotice,
	Str_SetGroupNotice,
	Str_InputGroupNotice,
	Str_GroupNick,
	Str_SetNick,
	Str_ToVerify,
	Str_PersonalInfo,
	Str_Birthday,
	Str_ImgUploading,
	Str_ImgUploadFail,
	Str_ServiceNumberCommonErr,
	Str_ServiceNumberCommonErr1,
	Str_ServiceNumberCommonErr2,
	Str_ServiceNumberInputHint,
	Str_ScannerEnter,
	Str_LoginLoading,
	Str_SwitchUserFail,
	Str_NickNotNull,
	Str_AccFormatErr,
	Str_AccNotNull,
	Str_PsdNotNull,
	Str_PsdNotEmpty,
	Str_PsdOldNotNull,
	Str_PsdLengthErr1,
	Str_PsdLengthErr2,
	Str_PsdOldLengthErr1,
	Str_PsdOldLengthErr2,
	Str_PsdFormatErr,
	Str_LogoutErr,
	Str_PsdInconsistent,
	Str_PhoneFormatErr,
	Str_EmailFormatErr,
	Str_Registering,
	Str_RegisterSuc,
	Str_RegisterFail,
	Str_InputNick,
	Str_InputAcc,
	Str_InputAcc2,
	Str_InputAcc3,
	Str_InputAcAgain,
	Str_InputCode,
	Str_InputPhone,
	Str_InputEmail,
	Str_InputPsd,
	Str_InputPsdAgain,
	Str_InputProblem,
	Str_InputAnswer,
	Str_HasAcc,
	Str_Binding,
	Str_BindSuc,
	Str_BindFail,
	Str_BindPhone,
	Str_BindEmail,
	Str_PlaceholderPsd,
	Str_PlaceholderProblem,
	Str_PlaceholderAnswer,
	Str_SetSuc,
	Str_SetFail,
	Str_Psd,
	Str_Problem,
	Str_Answer,
	Str_PhoneNotNull,
	Str_EmailNotNull,
	Str_CodeNotNull,
	Str_ChangeSuc,
	Str_ChangeFail,
	Str_InputOldPsd,
	Str_InputNewPsd,
	Str_InputNewPsdAgain,
	Str_OldPsd,
	Str_NewPsd,
	Str_Phone,
	Str_Album,
	Str_Camera,
	Str_TakePhoto,
	Str_Videotape,
	Str_Shot,
	Str_Email,
	Str_SetEmail,
	Str_UpdateEmail,
	Str_ConfirmPsd,
	Str_ProblemNotNull,
	Str_AnswerNotNull,
	Str_CommonLoading,
	Str_UpdatePsdTitle,
	Str_UpdatePsdLoading,
	Str_OpenSecurityLoading,
	Str_OpenSecurityTitle,
	Str_ThePsd,
	Str_Err500,
	Str_Err1013,
	Str_Err1014,
	Str_Err1015,
	Str_Err400,
	Str_Mine,
	Str_Wallet,
	Str_Announcement,
	Str_AccountSecurity,
	Str_PrivacySetting,
	Str_OtherSetting,
	Str_Logout,
	Str_ConfirmLogout,
	Str_Tip,
	Str_CopySuc,
	Str_CopyFail,
	Str_CopyTip,
	Str_ChangeLoginPsd,
	Str_ActivateSecurity,
	Str_ApplyDelAcc,
	Str_DelAccMsg1,
	Str_DelAccTip1,
	Str_DelAccTip2,
	Str_DelAccTip3,
	Str_DelAccTip4,
	Str_NextStep,
	Str_Help,
	Str_AboutApp,
	Str_Version,
	Str_SignOut,
	Str_CleanAllChatMsg,
	Str_CleanAllDialogMsg,
	Str_CleanAllDialogLoading,
	Str_CleanSuc,
	Str_CleanFail,
	Str_ChatMsgIsNull,
	Str_OpenNotify,
	Str_AccountPrivacy,
	Str_BlackManager,
	Str_SetSendMsgInterval,
	Str_ApplySuc,
	Str_ReportSuc,
	Str_Report,
	Str_GroupChat,
	Str_SingleChat,
	Str_PeopleChoose,
	Str_SendMsgPlaceholder,
	Str_AddMembers,
	Str_Clearing,
	Str_AlreadyTheGroup,
	Str_InProhibition,
	Str_Prohibition,
	Str_SpeakFrequently,
	Str_SendFail,
	Str_SendSuc,
	Str_NewInvitationJoinGroup,
	Str_ClearChatHistory,
	Str_You,
	Str_ScanCodeAddGroup,
	Str_Invited,
	Str_JoinGroupChat,
	Str_Pulling,
	Str_CreateGroupChat,
	Str_ExitedGroupChat,
	Str_KickOutGroupChat,
	Str_Cover,
	Str_YourFriendApproved,
	Str_Img,
	Str_Voice,
	Str_Video,
	Str_Talk,
	Str_WithdrawAMsg,
	Str_MessageForYou,
	Str_ReEdit,
	Str_OperationFailed,
	Str_OperationSuc,
	Str_Agree,
	Str_Refuse,
	Str_GroupApplication,
	Str_SensitiveMsgTip1,
	Str_SensitiveMsgTip2,
	Str_Copy,
	Str_Locate,
	Str_Translate,
	Str_TranslateComplete,
	Str_CancelTranslate,
	Str_Quote,
	Str_Forward,
	Str_Multi,
	Str_Delete,
	Str_Withdraw,
	Str_Speaker,
	Str_Receiver,
	Str_AddFriends,
	Str_Scan,
	Str_Chat,
	Str_Search,
	Str_Searching,
	Str_NoticeOpenTip,
	Str_Notice,
	Str_GoOpen,
	Str_Send,
	Str_SendImage,
	Str_Radio,
	Str_CheckBox,
	Str_CreateNewSession,
	Str_SelectSessionForwarding,
	Str_UserDoesNotExist,
	Str_ChatDetail,
	Str_SearchChatContent,
	Str_ChatTop,
	Str_MsgNotification,
	Str_Describe,
	Str_DescribeTip,
	Str_DelMember,
	Str_DelMemberTip,
	Str_DelMemberTip1,
	Str_ViewAllMembers,
	Str_GroupAvatar,
	Str_GroupQrCode,
	Str_MyNickname,
	Str_GroupAnnouncement,
	Str_GoSetting,
	Str_GroupManagement,
	Str_DelGroup,
	Str_TransferGroup,
	Str_TransferSuc,
	Str_TransferFail,
	Str_AddAdmin,
	Str_RemoveAdmin,
	Str_GroupEntryReview,
	Str_LookGroupList,
	Str_OpenUser,
	Str_FriendInviteEnter,
	Str_AllProhibition,
	Str_RemoveProhibition,
	Str_AllProhibitionTip,
	Str_GroupChatIntervalTime,
	Str_Second,
	Str_Year,
	Str_Month,
	Str_Day,
	Str_SelectYourBirthday,
	Str_Save,
	Str_Yesterday,
	Str_BeforeYesterday,
	Str_Monday,
	Str_Tuesday,
	Str_Wednesday,
	Str_Thursday,
	Str_Friday,
	Str_Saturday,
	Str_Sunday,
	Str_GroupMembers,
	Str_SpeakingTimeShort,
	Str_ReleaseFingerUpCancelSending,
	Str_FingerUpCancelSending,
	Str_HoldTalk,
	Str_Contact,
	Str_NewFriendInvitation,
	Str_ContactFriendTip,
	Str_ContactBlackTip,
	Str_Contacts,
	Str_Service,
	Str_ThroughVerification,
	Str_SendMsg,
	Str_LoadFail,
	Str_SendFriendApply,
	Str_QrCodeTip,
	Str_DelFriend,
	Str_DelFriendTip,
	Str_AddFriendBlackTip,
	Str_SettingInformation,
	Str_JoinBlacklist,
	Str_Passed,
	Str_See,
	Str_NewFriend,
	Str_EmailRetrieve,
	Str_PhoneRetrieve,
	Str_SecurityRetrieve,
	Str_NoData,
	Str_DelChat,
	Str_QrCodeGroupTip,
	Str_CameraPermissionErrorTip,
	Str_MicPermissionErrorTip,
	Str_WriteFilePermissionErrorTip,
	Str_AlbumPermissionErrorTip,
	Str_SendTo,
	Str_LeaveMessageFriends,
	Str_Reply,
	Str_SelectChat,
	Str_ChatRecord,
	Str_ErrorChatRecord,
	Str_CreateNewChat,
	Str_DelFail,
	Str_GroupChatHistory,
	Str_And,
	Str_OfChatRecord,
	Str_Feedback,
	Str_FeedbackText1,
	Str_FeedbackText2,
	Str_FeedbackImgDesc,
	Str_FeedbackImgText,
	Str_FeedbackToast1,
	Str_FeedbackToast2,
	Str_FeedbackToast3,
	Str_FeedbackSuc,
	Str_FeedbackFail,
	Str_FeedbackPlaceholder1,
	Str_FeedbackPlaceholder2,
	Str_TopicUntop,
	Str_MarkRead,
	Str_ScannerQRCodeErr,
	Str_FatchUserFailure,
	Str_CreateLabel,
	Str_CreateAddLabel,
	Str_LabelName,
	Str_Label,
	Str_LabelNotNull,
	Str_CreateSucc,
	Str_CreateFail,
	Str_ConstactLabel,
	Str_LabelEmpty,
	Str_AllLabel,
	Str_SelectOrSearchLabel,
	Str_Add,
	Str_ShiftOut,
	Str_Deleted,
	Str_DeleteFail,
	Str_DeleteSucc,
	Str_AddLabel,
	Str_LabelAlreadyExists,
	Str_AddSucc,
	Str_AddFail,
	Str_ShiftOutSucc,
	Str_ShiftOutFail,
	Str_SelectFriend,
	Str_SelectShiftOutMember,
	Str_UpdateLabelName,
	Str_NowLabelMemberEmpty,
	Str_DeleteLabel,
	Str_DeleteLabelTip,
	Str_SaveSucc,
	Str_QRCodeError,
	Str_SavePicture,
	Str_ApplyJoinGroup,
	Str_JoinGroupPlace,
	Str_SelectDate,
	Str_NewMsgCount,
	Str_Collect,
	Str_Draft,
	Str_MoreContacts,
	Str_Include,
	Str_MoreGroupChats,
	Str_RelatedChatRecords,
	Str_MoreChatRecord,
	Str_AddEmoticons,
	Str_OnlyGroupAdminCanEdit,
	Str_AnnouncementNotEmpty,
	Str_AccordingTo,
	Str_Find,
	Str_Member,
	Str_Date,
	Str_AccordingToDateFind,
	Str_QuickSearchMsgContent,
	Str_ReadCount,
	Str_Emit,
	Str_MyQRCode,
	Str_GroupNameNotNull,
	Str_Edit,
	Str_AddAddedSingleEmoticon,
	Str_Tidy,
	Str_ClearCache,
	Str_LanguageSwitching,
	Str_AlreadyRegistered,
	Str_AlreadyUsed,
	Str_AlreadyNotRegistered,
	Str_AlreadyBoundPhone,
	Str_AccountLogin,
	Str_PhoneLogin,
	Str_AddFriendTip,
	Str_ReadAgreed,
	Str_UserAgreement,
	Str_PrivacyPolicy,
	Str_ReadAgreedTip,
	Str_SwitchAccount,
	Str_ScannerPictureError,
	Str_Clear,
	Str_NowUse,
	Str_Manage,
	Str_AddAccount,
	Str_SwitchAccTip,
	Str_SwitchAccSuc,
	Str_AccDelTip,
	Str_CurrenAccInUse,
	Str_EmptyNotSend,
	Str_TopicTop,
	Str_SelectAll,
	Str_UnSelectAll,
	Str_MassSendingAssistant,
	Str_CreatTopicErr,
	Str_SendComplete,
	Str_GroupMessaging,
	Str_InputGroupContent,
	Str_GroupApplyTip,
	Str_No_images,
	Str_No_videos,
	Str_No_documents,
	Str_Group_owner,
	Str_Admin,
	Str_Group_no_images,
	Str_Group_no_videos,
	Str_Group_no_documents,
	Str_Forward_image_warning,
	Str_Forward_video_warning,
	Str_Forward_document_warning,
	Str_Admin_bold_font,
	Str_Admin_text_color,
	Str_Special_message,
	Str_Reject,
	Str_Rejected,
	Str_Canceled,
	Str_Unanswered,
	Str_OtherEndRejected,
	Str_OtherEndCanceled,
	Str_OtherEndUnanswered,
	Str_loginGuide,
	Str_accountBindingNotice,
	Str_dontRemind,
	Str_confirmChange,
	Str_identityHint,
	Str_setNickname,
	Str_RetrievePsd,
	Str_customerService,
	Str_RetrievePsdpPaceholder,
	Str_usernameMismatch,
	Str_enterCaptcha,
	Str_captchaError,
	Str_unknownError,
	Str_noRecoveryMethod,
	Str_featureTitle_1,
	Str_featureTitle_2,
	Str_featureTitle_3,
	Str_featureSubTitle_1,
	Str_featureSubTitle_2,
	Str_featureSubTitle_3,
	Str_Experience,
	Str_openPrivateChat,
	Str_LoginConfirm,
	Str_LoginConfirmTip,
	Str_QRCodeInvalid,
	Str_FileSizeLimit,
	Str_CanNoFindMsg,
	Str_ContactDeleted,
	Str_FindNewVersion,
	Str_UpdateNow,
	Str_UpdateLater,
	Str_MsgLoading,
	Str_UnbindEmailError,
	Str_Refresh,
	Str_BehavioralVerify,
	Str_BehavioralVerifyTip,
	Str_UpdateAvatar,
	Str_Myself,
	Str_Friends,
	Str_Moments,
	Str_Publish,
	Str_Publishing,
	Str_PublishContentNotEmpty,
	Str_PublishSuccess,
	Str_PublishFail,
	Str_SaySomething,
	Str_SupportContent,
	Str_MaxLimit,
	Str_HadCancelAuthorize,
	Str_HadChangeAccount,
	Str_AuthorizeHadExpired,
	Str_LogOutCurrentAccount,
	Str_LogOutAllAccount,
	Str_Reload,
	Str_MaxFileCountLimit,
	Str_FrequentTips,
	Str_AccountHadLoginThisDevice
};
